export default __webpack_public_path__ + "assets/img/footer_logo.png";